import { render, staticRenderFns } from "./Delivery.vue?vue&type=template&id=4b5db10a&scoped=true&"
import script from "./Delivery.vue?vue&type=script&lang=ts&"
export * from "./Delivery.vue?vue&type=script&lang=ts&"
import style0 from "./Delivery.vue?vue&type=style&index=0&id=4b5db10a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5db10a",
  null
  
)

export default component.exports